import Dataset from "./Dataset";

export default class Details extends Dataset {
  requiresFacilityMode = true;
  type = "feature";
}
